import {useTranslation} from 'react-i18next';
import {useUnit} from 'effector-react/effector-react.umd';
import {useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {$authStatus, $logoutDone, confirmAuthFx, LoginGate} from '../../models/authModel/index.js';
import {Button} from 'primereact/button';
import {Image} from 'primereact/image';
import {Card} from 'primereact/card';
import img from '../../assets/logo.png'
import Notification from '../../components/Notification/Notification.jsx';

export default function Login() {
    const {t} = useTranslation()
    const authStatus = useUnit($authStatus)
    const isLogout = useUnit($logoutDone)
    const navigate = useNavigate()
    const tokensFetching = useUnit(confirmAuthFx.pending)

    useEffect(() => {
        if (authStatus && !isLogout) {
            navigate('/')
        } else if (isLogout) {
            window.location.replace(CMS_BASE_URL)
        }
    }, [authStatus, isLogout]);

    return <div style={{height: '100vh', width: '100vw'}} className={'flex align-items-center justify-content-center'}>
        <Notification/>
        <LoginGate />
        <Card className={'flex align-items-center justify-content-center w-3'}>
            <div className={'flex flex-column gap-3 justify-content-center align-items-center'}>
                <Image src={img}/>
                {(tokensFetching)
                    ?
                    <div
                        className={'flex flex-column gap-1 justify-content-center align-items-center'}>
                        <i className="pi pi-spin pi-spinner" style={{fontSize: '2rem'}}/>
                        <span>{t('Проверка авторизации')}</span>
                    </div>
                    : <Link to={`${SSO_BASE_URL}/accounts/register/`}>
                        <Button className={'bg-transparent border-primary text-primary'} label={t('Регистрация')} outlined/>
                    </Link>}
            </div>
        </Card>
    </div>
}